export default __webpack_public_path__ + "static/media/RUBRIQUEKOJY-TRAD.0b1ca7e6.png";